import React from 'react';
import { Button, Popconfirm, Tooltip, Typography } from 'antd';
import { DeleteOutlined, EditOutlined, EyeOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { authorName } from './authors';
import type { ProgramUser } from '../../interfaces/CamProgramming.interface';

const { Text } = Typography;

/** How a timestamp reads in a table cell. */
export const formatLogged = (timestamp: string | null) =>
	timestamp ? dayjs(timestamp).format('MMM D, YYYY h:mm A') : '—';

/** Who wrote the entry, as the tables all show it. */
export const AuthorCell: React.FC<{
	user: ProgramUser | null;
	fallback?: string;
}> = ({ user, fallback }) => (
	<Text ellipsis>{authorName(user, fallback)}</Text>
);

/**
 * The buttons closing every row. Editing and removing stay as quiet icons,
 * while view is spelled out and sits last: a table row says nothing about what
 * was written, so it is the one action every row needs and the one worth
 * landing on at the end of the line.
 */
export const EntryTableActions: React.FC<{
	onView: () => void;
	onEdit?: () => void;
	onDelete?: () => void;
	deleteConfirmTitle: string;
}> = ({ onView, onEdit, onDelete, deleteConfirmTitle }) => (
	<div className="cam-table-actions">
		{onEdit && (
			<Tooltip title="Edit">
				<Button
					type="text"
					size="small"
					icon={<EditOutlined />}
					onClick={onEdit}
				/>
			</Tooltip>
		)}
		{onDelete && (
			<Popconfirm
				title={deleteConfirmTitle}
				okText="Remove"
				okButtonProps={{ danger: true }}
				onConfirm={onDelete}
			>
				<Tooltip title="Remove">
					<Button type="text" size="small" danger icon={<DeleteOutlined />} />
				</Tooltip>
			</Popconfirm>
		)}
		<Button size="small" icon={<EyeOutlined />} onClick={onView}>
			View
		</Button>
	</div>
);
